import { render, staticRenderFns } from "./StartMeasuringModal.vue?vue&type=template&id=5c6506dc&scoped=true&"
import script from "./StartMeasuringModal.vue?vue&type=script&lang=js&"
export * from "./StartMeasuringModal.vue?vue&type=script&lang=js&"
import style0 from "./StartMeasuringModal.vue?vue&type=style&index=0&id=5c6506dc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c6506dc",
  null
  
)

/* custom blocks */
import block0 from "./StartMeasuringModal.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

/* hot reload */
if (module.hot) {
  var api = require("/builds/RXxibax4-/0/opiniooon/opnn-analytics/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5c6506dc')) {
      api.createRecord('5c6506dc', component.options)
    } else {
      api.reload('5c6506dc', component.options)
    }
    module.hot.accept("./StartMeasuringModal.vue?vue&type=template&id=5c6506dc&scoped=true&", function () {
      api.rerender('5c6506dc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/tablet-migration/StartMeasuringModal.vue"
export default component.exports